// One reactive unread count, shared by the tab bar's badge and the room's
// bell (in-app notifications v1, ruled 2026-09-05). Fed by
// notificationsService.watchUnread; nothing else writes it.
import { reactive } from 'vue';

export const notifStore = reactive({ unread: 0 });
export default notifStore;
